import { render } from "./ChilderingProblems.vue?vue&type=template&id=e9c32c8c"
import script from "./ChilderingProblems.vue?vue&type=script&lang=js"
export * from "./ChilderingProblems.vue?vue&type=script&lang=js"

import "./ChilderingProblems.vue?vue&type=style&index=0&id=e9c32c8c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__